import MIME from 'mime'
import _ from 'lodash'

export const checkUrlImage = (url) => {
  return new Promise((resolve, reject) => {
    const image = new Image()
    image.src = url
    image.onload = () => resolve(image)
    image.onerror = () => reject({ error: 'fail to load', fail: true })
  })
}

export const getFileType = (fileName) => {
  try {
    const names = fileName.split('.')
    let fileType = ''
    if (names.length > 0) {
      fileType = _.get(names, `${[names.length - 1]}`)
      let fileGroup = MIME.getType(fileType)
      if (fileGroup) {
        fileGroup = fileGroup.split('/')[0]
        if (fileGroup === 'audio') {
          return 'audio'
        }
        if (fileGroup === 'video') {
          return 'video'
        }
        if (fileGroup === 'image') {
          return 'image'
        }
      }
    }
    return fileType
  } catch (error) {
    return 'invalid-type'
  }
}

export function getFileSizeText(size) {
  const sizeInKB = (size / 1000).toFixed(2)
  const sizeInMB = (sizeInKB / 1000).toFixed(2)
  const sizeInGB = (sizeInMB / 1000).toFixed(2)
  // If the number is less than or equal to one thousand, then it's a KB
  if (sizeInKB > 1000) {
    if (sizeInMB > 1000) {
      return `${sizeInGB}GB`
    }
    return `${sizeInMB}MB`
  }
  return `${sizeInKB}KB`
}

export function shortenFilename(filename, maxLength) {
  const lastDotPosition = filename.lastIndexOf('.')
  if (lastDotPosition === -1) {
    return filename
  }

  const name = filename.substring(0, lastDotPosition)
  const ext = filename.substring(lastDotPosition)

  const shortenedName = name.length > maxLength ? name.substring(0, maxLength) : name

  return `${shortenedName}...${ext}`
}

export function downloadUrl(url, fileName) {
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
